import ja from './ja'
// import aaa from './aaa'
import { deepObjectMerge } from '@/utils/utils.js'
import v1 from './v1'
import v2 from './v2'
import v6 from './v6'
export default deepObjectMerge(
  ja,
  v1,
  v2,
  v6
)

// function getKey (array, baseKey, obj) {
//   let keys = Object.keys(obj)
//   keys.forEach((key) => {
//     let value = obj[key]
//     if (value.toString() === '[object Object]') {
//       if (baseKey === '') {
//         getKey(array, key, value)
//       } else {
//         getKey(array, baseKey + '.' + key, value)
//       }
//     } else {
//       if (baseKey === '') {
//         array.push(key)
//       } else {
//         array.push(baseKey + '.' + key)
//       }
//     }
//   })
// }

// function getDiff(arry1, array2) {
//   let diffArray = []
//   arry1.forEach((key) => {
//     if (!array2.includes(key)) {
//       diffArray.push(key)
//     }
//   })
//   return diffArray
// }

// let zhkeys = []
// getKey(zhkeys, '', ja)
// let keyString = zhkeys.toString()
// let a = 0
// let obj = {}
// Object.keys(aaa).forEach((key) => {
//   let reg = new RegExp(key, 'g')
//   if (keyString.match(reg) && keyString.match(reg).length === 1) {
//     zhkeys.forEach((keya) => {
//       let keyArry = keya.split('.')
//       if (keyArry.indexOf(key) === 0) {
//         if (obj[key]) {
//           obj[key] = obj[key] + 1
//         } else {
//           obj[key] = 1
//         }
//         let value = aaa[key]
//         ja[keya] = value + '==88aaaaaaaaa==='
//         a++
//       } else if (keyArry.indexOf(key) === 1) {
//         if (obj[key]) {
//           obj[key] = obj[key] + 1
//         } else {
//           obj[key] = 1
//         }
//         a++
//         let value = aaa[key]
//         ja[keyArry[0]][keyArry[1]] = value + '==88aaaaaaaaa==='
//       }
//     })
//   } else if (keyString.match(reg) && keyString.match(reg).length > 0) {
//     let jaStr = JSON.stringify(ja)
//     let reg1 = new RegExp('"' + key + '":"' + aaa[key] + '"', 'g')
//     let regResult = jaStr.match(reg1)
//     if (regResult && regResult.length === 1) {
//     } else if (regResult && regResult.length > 1) {
//       console.error('重复key ' + key + ": '" + aaa[key] + "'")
//     }
//   } else {
//     console.log('未找到匹配key ' + key)
//   }
// })
// console.log(JSON.stringify(obj))
// console.log('处理' + a + '个值')
// console.log(JSON.stringify(ja))



// WEBPACK FOOTER //
// ./src/i18n/languages/ja/index.js